var exports = {
  "kL": "SensitiveContentTab.module__container___R3BtT2",
  "nM": "SensitiveContentTab.module__row___R3BtT2",
  "Pf": "SensitiveContentTab.module__label___R3BtT2",
  "fR": "SensitiveContentTab.module__labelDisabled___R3BtT2",
  "Sx": "SensitiveContentTab.module__choiceWrap___R3BtT2",
  "$5": "SensitiveContentTab.module__choiceGroup___R3BtT2",
  "fr": "SensitiveContentTab.module__choiceGroupDisabled___R3BtT2",
  "CH": "SensitiveContentTab.module__choiceButton___R3BtT2",
  "sn": "SensitiveContentTab.module__choiceButtonActive___R3BtT2",
  "Hm": "SensitiveContentTab.module__choiceIndicator___R3BtT2",
};

module.exports = exports;
